<template>
  <v-app>
    <v-app-bar app color="grey darken-2" dark>
      <img src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg" alt="Logo HEIG-VD" height="70%" class="logo" />
      <div class="d-flex align-center ml-5">DEMANDES D'ACCÈS AUX BÂTIMENTS</div>
      <v-spacer></v-spacer>
      <user-profile />
    </v-app-bar>
    <v-content>
      <v-container>
        <v-row class="mt-10 mb-0">
          <v-col>
            <router-link to="/nouvelles-demandes">Accueil</router-link>
            <div class="separator mx-3">|</div>
            <router-link to="/historique">Historique</router-link>
            <div class="separator mx-3">|</div>
            <router-link to="/liste-des-presences">Liste des présences</router-link>
          </v-col>
        </v-row>
      </v-container>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile";
export default {
  name: "App",
  components: {
    UserProfile
  }
};
</script>

<style>
.separator {
  display: inline-block;
}
</style>
